/* eslint @typescript-eslint/explicit-function-return-type: off */

import React from 'react';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';
import AdPerformanceReportDataSource from '../../../models/AdPerformanceReportDataSource';
import SegmentFieldForm from './SegmentFieldsForm/SegmentFieldForm';

const scope =
  'frontend.components.AdPerformanceReportDataSource.Form.SegmentFieldsForm';

const propTypes = {
  dataSource: PropTypes.exact(AdPerformanceReportDataSource.propTypes),
  onChange: PropTypes.func,
};

class SegmentFieldsForm extends React.Component {
  static propTypes = propTypes;

  constructor(props) {
    super(props);

    this.handleAdd = this.handleAdd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleAdd(event) {
    event.preventDefault();
    const { dataSource, onChange } = this.props;
    const segmentFields = dataSource.segmentFields.slice();
    segmentFields.push(dataSource.buildSegmentField());
    onChange({ ...dataSource, segmentFields });
  }

  handleChange(index) {
    return (field, event) => {
      event.preventDefault();
      const { dataSource, onChange } = this.props;
      const segmentFields = dataSource.segmentFields.slice();
      segmentFields[index] = field;
      onChange({ ...dataSource, segmentFields });
    };
  }

  handleRemove(index) {
    return (event) => {
      event.preventDefault();
      const { dataSource, onChange } = this.props;
      const segmentFields = dataSource.segmentFields.slice();
      segmentFields.splice(index, 1);
      onChange({ ...dataSource, segmentFields });
    };
  }

  render() {
    const { dataSource } = this.props;
    const {
      segmentFields,
      minSegmentFieldCount: min,
      maxSegmentFieldCount: max,
    } = dataSource;

    return (
      <>
        <BS.Table responsive striped bordered hover className='form-table'>
          <thead>
            <tr>
              <th className='fixed-xlarge' colSpan='3'>
                {I18n.t(`${scope}.table.heading.source`)}
              </th>
              <th className='fixed-xlarge'>
                {I18n.t(`${scope}.table.heading.target`)}
              </th>
              <th className='fixed-min' />
            </tr>
          </thead>
          <tbody>
            {segmentFields.map((field, index) => (
              <SegmentFieldForm
                key={index}
                dataSource={dataSource}
                field={field}
                onChange={this.handleChange(index)}
                onRemove={min <= index && this.handleRemove(index)}
              />
            ))}
          </tbody>
        </BS.Table>
        {segmentFields.length < max && (
          <a className='pull-right' href='' onClick={this.handleAdd}>
            <span
              dangerouslySetInnerHTML={{
                __html: I18n.t(`${scope}.action.add`),
              }}
            ></span>
          </a>
        )}
      </>
    );
  }
}

export default SegmentFieldsForm;
